import "antd/es/avatar/style";
import _Avatar from "antd/es/avatar";
import "antd/es/dropdown/style";
import _Dropdown from "antd/es/dropdown";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Typography from '../typography';
import { ArrowDownOutlined, ArrowUpOutlined, BurgerMenuOutlined, CrossOutlined } from 'iglooicon';
import classnames from 'classnames';
import defaultAvatar from './style/avatar.svg';
import './style/index';

var HomeMenu = function HomeMenu(props) {
  var useBreakpoint = _Grid.useBreakpoint;

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var className = props.className,
      style = props.style,
      customInfos = props.customInfos,
      actions = props.actions,
      _props$userAvatar = props.userAvatar,
      userAvatar = _props$userAvatar === void 0 ? defaultAvatar : _props$userAvatar,
      userName = props.userName;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  if (!md) {
    return _jsx(_Dropdown, {
      className: classnames(className, 'igloo-home-drop-down-mobile-container'),
      overlayStyle: style,
      onVisibleChange: function onVisibleChange(visible) {
        return setOpen(visible);
      },
      trigger: ['click'],
      getPopupContainer: function getPopupContainer(trigger) {
        return trigger.parentElement || document.body;
      },
      overlay: _jsxs("div", {
        className: "igloo-home-drop-down-mobile-overlay-container",
        children: [_jsxs("div", {
          className: "menu-top",
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: [_jsx(_Avatar, {
            size: 32,
            src: userAvatar
          }), _jsxs("div", {
            className: "top-info",
            children: [_jsx(Typography, {
              level: "body1",
              children: userName
            }), _jsx("div", {
              style: {
                marginTop: 4
              },
              children: customInfos.map(function (info, index) {
                return _jsxs(Typography, {
                  level: "body3",
                  children: [info.title, " ", info.value]
                }, index);
              })
            })]
          })]
        }), _jsx("div", {
          className: "menu-actions",
          children: actions.map(function (action, index) {
            var _onClick = action.onClick;
            return _jsx("div", {
              className: "action-item",
              onClick: function onClick() {
                _onClick && _onClick();
                setOpen(false);
              },
              children: _jsx(Typography, {
                level: "body1",
                children: action.title
              }, index)
            }, index);
          })
        })]
      }),
      children: _jsxs("div", {
        className: "arrow-container",
        children: [_jsx(CrossOutlined, {
          className: "arrow-active",
          style: {
            opacity: "".concat(open ? 1 : 0)
          }
        }), _jsx(BurgerMenuOutlined, {
          className: "arrow-default",
          style: {
            opacity: "".concat(open ? 0 : 1)
          }
        })]
      })
    });
  }

  return _jsx(_Dropdown, {
    className: classnames(className, 'igloo-home-drop-down-container'),
    overlayStyle: style,
    onVisibleChange: function onVisibleChange(visible) {
      return setOpen(visible);
    },
    placement: "bottomRight",
    trigger: ['click'],
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentElement || document.body;
    },
    overlay: _jsxs("div", {
      className: "igloo-header-drop-down-menu",
      children: [_jsx("div", {
        className: "menu-top",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: customInfos.map(function (info, index) {
          return _jsxs(Typography, {
            level: "body2",
            children: [info.title, " ", info.value]
          }, index);
        })
      }), _jsx("div", {
        className: "menu-actions",
        children: actions.map(function (action, index) {
          var _onClick2 = action.onClick;
          return _jsx("div", {
            className: "action-item",
            onClick: function onClick() {
              _onClick2 && _onClick2();
              setOpen(false);
            },
            children: _jsx(Typography, {
              level: "body1",
              children: action.title
            }, index)
          }, index);
        })
      })]
    }),
    children: _jsxs("div", {
      className: "arrow-container",
      children: [_jsx(ArrowUpOutlined, {
        className: "arrow-active",
        style: {
          opacity: "".concat(open ? 1 : 0)
        }
      }), _jsx(ArrowDownOutlined, {
        className: "arrow-default",
        style: {
          opacity: "".concat(open ? 0 : 1)
        }
      })]
    })
  });
};

export default HomeMenu;